import { useEffect, useState } from "react";
import { collection, getFirestore, onSnapshot, query, where } from "firebase/firestore";
import { BiSearch } from "react-icons/bi";
import { DropdownButton, Table, Dropdown } from "react-bootstrap";
import RequestRow from "./components/requestRow";
import RequestDetails from "./components/requestDetails";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs, { Dayjs } from "dayjs";

export default function Requests() {


    const db = getFirestore();
    const [search, setSearch] = useState("");
    const [orders, setorders] = useState([]);
    const [orderIds, setOrderIds] = useState([]);
    const [seeDetails, setSeeDetails] = useState(false);
    const [currentOrder, setCurretnOrder] = useState("");
    const [currentCategory, setCurrentCategory] = useState("");
    const [startDate,setStartDate]=useState( dayjs().subtract(60,"day").toDate() );
    const [endDate,setEndDate]=useState(dayjs().toDate());

    const handleSearchChange = (e) => {
        setSearch(e.target.value.trim());
        console.log(e.target.value);
    }



    useEffect(
        async () => {
            const q = query(collection(db, "requests"),where("createdAt",">=",startDate),where("createdAt","<=",endDate));
            var tempList = [];
            var tempIdsList = [];
            const unsubscribe = onSnapshot(q, (querySnapshot) => {

                tempList=[];
                tempIdsList=[];
                querySnapshot.forEach((doc) => {
                    let data = doc.data();
                    if (
                        doc.id.toLowerCase().includes(search.trim().toLowerCase())
                        || data["user"].toString().toLowerCase().includes(search.trim().toLowerCase())
                        || data["celebrity"].toString().toLowerCase().includes(search.trim().toLowerCase())
                    ) {

                        if (currentCategory == ""){
                            tempList.push(data);
                            tempIdsList.push(doc.id);
                        }
                        else if (data["type"] == currentCategory) {
                            tempList.push(data);
                            tempIdsList.push(doc.id);
                        }

                    }
                });



                setorders(tempList);
                setOrderIds(tempIdsList);
            });



            return function cleanup() {
                unsubscribe();
            };
        },
        [search, currentCategory,startDate,endDate]
    );






    return (
        <div className="relative bg-transparent w-full h-full">

            {seeDetails === true ?
                <RequestDetails
                    closeButton={() => {
                        setSeeDetails(false);
                    }}
                    id={currentOrder}
                /> :
                <div className="z-10 absolute" />}



            <div className="relative h-full w-full p-10 flex justify-start items-start flex-col">

                <div className="text-white font-bold rounded-sm text-3xl mb-5">Requests</div>

                <div className="flex flex-row w-2/4 bg-white mb-5 ">
                    <input
                        onChange={(e) => { handleSearchChange(e) }}
                        placeholder="Search"
                        className="w-11/12 p-3 text-black bg-white border-0 outline-0 shadow-xl" />

                    <div className="w-1/12 flex justify-center items-center">
                        <BiSearch size={40} color={"black"} />
                    </div>

                </div>


                <DropdownButton split variant="warning" title={`${currentCategory == "" ? "Select Category" : currentCategory}`} className="h-12 w-24 mb-12">
                    <Dropdown.Item onClick={() => { setCurrentCategory("") }} >All</Dropdown.Item>
                    <Dropdown.Item onClick={() => { setCurrentCategory("dm") }} >DM</Dropdown.Item>
                    <Dropdown.Item onClick={() => { setCurrentCategory("videoRequest") }}>Video Request</Dropdown.Item>
                    <Dropdown.Item onClick={() => { setCurrentCategory("eventBooking") }}>Event Booking</Dropdown.Item>
                </DropdownButton>



                <div className="flex flex-row gap-4">
                    
                    <div className="flex flex-col justify-center items-start">
                    <div>Starting Date</div>
                        <DatePicker
                        className="mb-10 text-black p-2 rounded-md"
                        selected={startDate}
                        onSelect={(date)=>setStartDate(date)} //when day is clicked
                        />
                    </div>


                    <div className="flex flex-col justify-center items-start">
                    <div>Ending Date</div>
                        <DatePicker
                        className="mb-10 text-black p-2 rounded-md"
                        selected={endDate}
                        onSelect={(date)=>setEndDate(date)} //when day is clicked
                        />
                    </div>


                </div>



                <div className="w-full" >
                    <Table bordered className="text-white table-fixed">

                        <thead>
                            <tr className="w-full">
                                <th>
                                    <div className="flex justify-center">
                                        Amount
                                    </div>
                                </th>
                                <th>
                                    <div className="flex justify-center">
                                        Message
                                    </div>
                                </th>
                                <th>
                                    <div className="flex justify-center">
                                        from
                                    </div>
                                </th>
                                <th>
                                    <div className="flex justify-center">
                                        to
                                    </div>
                                </th>
                                <th>
                                    <div className="flex justify-center">
                                        Type
                                    </div>
                                </th>
                                <th>
                                    <div className="flex justify-center">
                                        Date
                                    </div>
                                </th>

                                <th>
                                    <div className="flex justify-center">
                                        Status
                                    </div>
                                </th>

                                <th>
                                    <div className="flex justify-center">

                                    </div>
                                </th>

                            </tr>
                        </thead>



                        <tbody>
                            {
                                orders.map(
                                    (ordersData, orderIndex) => {
                                        return (
                                            <RequestRow
                                                seeOrderInfo={() => {
                                                    setSeeDetails(true);
                                                    setCurretnOrder(orderIds[orderIndex]);
                                                }}
                                                key={ordersData["createdAt"]}
                                                data={ordersData} />
                                        )
                                    }
                                )
                            }
                        </tbody>


                    </Table>
                </div>



            </div>

        </div>
    )
}